<template>
   <b-modal id="languages" size="xl" content centered ok-only>
       <template v-slot:modal-header>
        <div class="header">
          <div class="header_icon">
            <b-icon icon="suit-club-fill"></b-icon>
          </div>
          <div>
            <h3> Memory Game</h3>
            <p style="font-style: italic">Choose the language and play!</p>
          </div>
        </div>
      </template>
       <b-container fluid>
           <b-row class="game_info">
                <div class="scores">
                    <div class="turns"><span class="btn btn-info">Turns : <span class="badge" :class="finish ? 'badge-success' : 'badge-light'">{{turns}}</span> </span></div>
                    <div class="totalTime"><span class="btn btn-info">Total Time : <span class="badge" :class="finish ? 'badge-success' : 'badge-light'">{{min}} : {{sec}}</span></span></div>
                    <div class="totalTime"><button class="btn btn-info reset" @click="reset" :disabled="!start">Restart</button></div>
                </div>
                <div class="flags">
                    <div  v-for="(flag, i) in flags" :key="i">
                        <b-img :src="flag.flag" thumbnail @click="chooseLanguage(flag.name)"></b-img>
                    </div>
                </div>
           </b-row>
           <b-row style="justify-content: center">
                <div v-for="(card, i) in memoryCards" :key="i" class="col-auto mb-3 flip-container"
                    :class="{ 'flipped': card.isFlipped, 'matched' : card.isMatched }" @click="flipCard(card)">
                    <div class="memorycard">
                        <div class="front border rounded shadow">
                            <b-img :src="frontCard" fluid></b-img>
                        </div>
                        <div class="back rounded border">
                            <b-img v-if="card.type === 'image'" :src="card.image" fluid></b-img>
                            <div v-else-if="card.type === 'text'" class="text">
                                <span>{{card.name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
           </b-row>
       </b-container>
   </b-modal>
</template>

<script>
const _ = require('lodash')
export default {
    data () {
        return {
            languages: ['vietnamese', 'english', 'french', 'japanese'],
            memoryCards: [],
            flippedCards: [],
            currentLanguage: 'english',
            start: false,
            turns: 0,
            totalTime: {
                minutes: 0,
                seconds: 0,
            },
            finish: false,
            flags: [
                {
                    name: 'vietnamese',
                    flag: require('../assets/memoryCards/vietnamese.png'),
                },
                {
                    name: 'english',
                    flag: require('../assets/memoryCards/uk.jpg'),
                },
                {
                    name: 'french',
                    flag: require('../assets/memoryCards/france.png'),
                },
                {
                    name: 'japanese',
                    flag: require('../assets/memoryCards/japan.png'),
                },
            ],
            cards: [
                {
                    name: 'sun',
                    image: require('../assets/memoryCards/sun.jpg'),
                },
                {
                    name: 'roses',
                    image: require('../assets/memoryCards/roses.jpg'),
                },
                {
                    name: 'tree',
                    image: require('../assets/memoryCards/tree.png'),
                },
                {
                    name: 'sea',
                    image: require('../assets/memoryCards/sea.jpg'),
                },
                {
                    name: 'mountain',
                    image: require('../assets/memoryCards/mountain.jpg'),
                },
                {
                    name: 'moon',
                    image: require('../assets/memoryCards/moon.jpg'),
                },
            ],
            vietnameseCards: [
                {
                    name: 'mặt trời',
                    image: require('../assets/memoryCards/sun.jpg'),
                },
                {
                    name: 'hoa hồng',
                    image: require('../assets/memoryCards/roses.jpg'),
                },
                {
                    name: 'cây',
                    image: require('../assets/memoryCards/tree.png'),
                },
                {
                    name: 'biển',
                    image: require('../assets/memoryCards/sea.jpg'),
                },
                {
                    name: 'núi',
                    image: require('../assets/memoryCards/mountain.jpg'),
                },
                {
                    name: 'mặt trăng',
                    image: require('../assets/memoryCards/moon.jpg'),
                },
            ],
            frenchCards: [
                {
                    name: 'soleil',
                    image: require('../assets/memoryCards/sun.jpg'),
                },
                {
                    name: 'rose',
                    image: require('../assets/memoryCards/roses.jpg'),
                },
                {
                    name: 'arbre',
                    image: require('../assets/memoryCards/tree.png'),
                },
                {
                    name: 'mer',
                    image: require('../assets/memoryCards/sea.jpg'),
                },
                {
                    name: 'montagne',
                    image: require('../assets/memoryCards/mountain.jpg'),
                },
                {
                    name: 'lune',
                    image: require('../assets/memoryCards/moon.jpg'),
                },
            ],
            japaneseCards: [
                {
                    name: '太陽',
                    image: require('../assets/memoryCards/sun.jpg'),
                },
                {
                    name: 'ローズ',
                    image: require('../assets/memoryCards/roses.jpg'),
                },
                {
                    name: '木',
                    image: require('../assets/memoryCards/tree.png'),
                },
                {
                    name: '海',
                    image: require('../assets/memoryCards/sea.jpg'),
                },
                {
                    name: '山',
                    image: require('../assets/memoryCards/mountain.jpg'),
                },
                {
                    name: '月',
                    image: require('../assets/memoryCards/moon.jpg'),
                },
            ],
        }
    },
    created () {
        this.chooseLanguage('english')
        // this.reset()
    },
    computed: {
        sec () {
            if (this.totalTime.seconds < 10) {
                return '0' + this.totalTime.seconds
            }
            return this.totalTime.seconds
        },
        min () {
            if (this.totalTime.minutes < 10) {
                return '0' + this.totalTime.minutes
            }
            return this.totalTime.minutes
        },
    },
    methods: {
        chooseLanguage (lang) {
            const EngFlag = require('../assets/memoryCards/uk.jpg')
            const VietFlag = require('../assets/memoryCards/vietnamese.png')
            const FraFlag = require('../assets/memoryCards/france.png')
            const JanFlag = require('../assets/memoryCards/japan.png')
            if (lang === 'english') {
                this.cardDeck(this.cards, EngFlag)
            }
            if (lang === 'vietnamese') {
                this.cardDeck(this.vietnameseCards, VietFlag)
            }
            if (lang === 'french') {
                this.cardDeck(this.frenchCards, FraFlag)
            }
            if (lang === 'japanese') {
                this.cardDeck(this.japaneseCards, JanFlag)
            }

            this.totalTime.minutes = 0
            this.totalTime.seconds = 0
            this.turns = 0
            this.start = false
            this.finish = false
            this.flippedCards = []
            this.currentLanguage = lang
        },
        cardDeck (lang, flag) {
            this.memoryCards = _.shuffle([].concat(lang.map(card => ({
                ...card,
                type: 'image',
                isFlipped: false,
                isMatched: false,
            })), lang.map(card => ({
                ...card,
                type: 'text',
                isFlipped: false,
                isMatched: false,
            }))))
            this.frontCard = flag
        },
        flipCard (card) {
            if (card.isMatched || card.isFlipped || this.flippedCards.length === 2) { return }
            if (!this.start) {
                this._startGame()
            }
            card.isFlipped = true
            if (this.flippedCards.length < 2) { this.flippedCards.push(card) }
            if (this.flippedCards.length === 2) { this._match(card) }
        },
        _match () {
            this.turns++

            if (this.flippedCards[0].name === this.flippedCards[1].name) {
                setTimeout(() => {
                    this.flippedCards.forEach(card => { card.isMatched = true })
                    this.flippedCards = []
                    // All cards matched ?
                    if (this.memoryCards.every(card => card.isMatched)) {
                        clearInterval(this.interval)
                        this.finish = true
                    }
                }, 400)
            } else {
                setTimeout(() => {
                    this.flippedCards.forEach(card => { card.isFlipped = false })
                    this.flippedCards = []
                }, 800)
            }
        },
        _startGame () {
            this._tick()
            this.interval = setInterval(this._tick, 1000)
            this.start = true
        },

        _tick () {
            if (this.totalTime.seconds !== 59) {
                this.totalTime.seconds++
                return
            }

            this.totalTime.minutes++
            this.totalTime.seconds = 0
        },
        reset () {
            clearInterval(this.interval)

            this.cards.forEach((card) => {
                card.isFlipped = false
                card.isMatched = false
            })

            setTimeout(() => {
                this.chooseLanguage(this.currentLanguage)
                this.totalTime.minutes = 0
                this.totalTime.seconds = 0
                this.start = false
                this.finish = false
                this.turns = 0
                this.flippedCards = []
            }, 600)
        },
    },
}
</script>

<style scoped lang="scss">
@import '../styles/components/Languages.scss'
</style>
